module.exports = __webpack_public_path__ + "static/media/plainomelette.2061e8e5.png";